import { isArray, isInteger } from 'lodash';
import { types as soTypes, actions as soActions } from './salesOrders';


export const types = {
	RESET_ALL: 'SALESORDERLINES/RESET_ALL',
	UPDATE_LINE: 'SALESORDERLINES/UPDATE_LINE',
	DELETE_LINE: 'SALESORDERLINES/DELETE_LINE',
	REPLACE_STATE: 'SALESORDERLINES/REPLACE_STATE',
};

/*
const queryLines = `SELECT
--ISNULL ( RDR1.U_ItemFreight, 0 ) as "U_ItemFreight",
--ISNULL ( RDR1.U_ItemTaxAmount, 0 ) as "U_ItemTaxAmount",
--ISNULL ( RDR1.U_DiscSum, '' ) as "U_DiscSum",
--ISNULL ( RDR1.U_Item_Disc, '' ) as "U_Item_Disc",
--ISNULL ( RDR1.U_A_CREFNO, '' ) as "U_A_CREFNO",
`;
*/

const defaultTaxCode = 'UPDATE';

const lineTemplate = {
	Key: '',
	Item: '',
	Description: '',
	LineStatus: 'O',
	WhsCode: '',
	Qty: 0,
	Price: 0,
	BasePrice: 0,
	LineTotal: 0,
	BPCatNum: '',
	PoTrgNum: '',
	UomCode: '',
	DiscountByPercent: 0,
	U_BinLocation: '',
	U_MainWhseStk: '',
	U_DSDescription: '',
	U_Backordered: 'N',
	TaxStatus: '',
	TaxCode: defaultTaxCode,
	BinLocation: '',
	removable: true,
	childCount: 0,
	OnOrder: 0,
	Committed: 0,
	VendorNum: '',
	LineNum: null,
	SalesEmployeeCode: '',
};

export const initialState = [{...lineTemplate}];


export default (state = initialState, action) => {
	switch (action.type) {
		case types.RESET_ALL:
			return [{...lineTemplate}];
		case types.UPDATE_LINE:
			return updateLine(state, action);
		case types.DELETE_LINE:
			let childCount = state[action.lineID].childCount || 0;
			return [ ...state.slice(0, action.lineID), ...state.slice(action.lineID + 1 + childCount) ];
		case types.REPLACE_STATE:
			return [ ...action.data ];
		default:
			return state;
	}
}

export const actions = {
	resetAll: () => ({ type: types.RESET_ALL }),
	addEmptyLine: () => {
		return (dispatch, getState) => {
			let state = getState();
			let taxCode = state.salesOrders.order.TaxCode || defaultTaxCode;

			dispatch({
				type: types.REPLACE_STATE,
				data: [ ...state.salesorderLines, {...lineTemplate, TaxCode: taxCode} ],
			});
		}
	},

	updatePricing: (rowID, key, value) => {
		return (dispatch, getState) => {
			value = Number(value || 0);
			let state = getState().salesorderLines;
			let row   = recalculateAmounts(state[rowID], { ...state[rowID], [key]: value });
			let rows  = [ row ];
			let qtyDivisor = 1;
			let oldRow = state[rowID];

			if(key === 'Qty') {
				qtyDivisor = oldRow.Qty / row.Qty;
			}

			if(row.childCount) {
				for(let i = (rowID + 1); i <= (rowID + row.childCount); i++) {
					let newRow = {...state[i]};
					if(qtyDivisor !== 1) {
						newRow.Qty = newRow.Qty / qtyDivisor;
					}

					//let newRow = recalculateAmounts(state[i], { ...state[i], [key]: value });

					rows.push(newRow);
				}
			}

			dispatch({
				type: types.REPLACE_STATE,
				data: [ ...state.slice(0, rowID), ...rows, ...state.slice(rowID + rows.length) ]
			});
			dispatch(soActions.updateTotals());
		}
	},



	deleteLine: (lineID) => {
		return (dispatch, getState) => {
			let state = getState();
			let lines = state.salesorderLines;
			if(lines.length-1 === lineID) {
				return false;
			}

			//let childCount = lines[lineID].childCount || 0;
			let removedKeys = [];

			//for(let i = lineID; i <= (lineID + childCount); i++) {

			if(lines[lineID] && (lines[lineID].Key || lines[lineID].Key === 0)) {
				removedKeys.push(lines[lineID].Key)
			} else {
				console.log(lineID, lines[lineID])
			}

			if(removedKeys.length) {
				let orderUpdate = { deletedLines: [ ...state.salesOrders.deletedLines, ...removedKeys ] };
				dispatch({type: soTypes.SET_STATE, data: orderUpdate});
			}

			dispatch({type: types.DELETE_LINE, lineID});
			dispatch(soActions.updateChanged());
			dispatch(soActions.updateTotals());
		}
	},



	updateLine: (data, lineID = null) => {
		return (dispatch, getState) => {
			let state = getState();
			let taxCode = state.salesOrders.order.TaxCode || defaultTaxCode;
			let slpCode = state.appData.UserSlpCode;
			if(data.TaxCode) {
				taxCode = data.TaxCode;
			}

			dispatch({type: types.UPDATE_LINE, data, lineID, taxCode, slpCode});
			dispatch(soActions.updateTotals());
			dispatch(soActions.updateChanged());
		}
	},

};


function updateLine(state, action) {
	let newLines = isArray(action.data) ? action.data : [ action.data ];
	let pos = action.lineID;

	newLines = newLines.map(line => {
		let existing = (isInteger(pos) && state[pos]) ? state[pos] : {};
		let newLine = {...lineTemplate, ...existing, ...line};

		if(!newLine.SalesEmployeeCode) newLine.SalesEmployeeCode = action.slpCode;

		if(isInteger(pos) && state[pos]) {
			newLine = recalculateAmounts(state[pos], newLine);
			// Knock that off, GPP
			newLine.UnitPrice = newLine.BasePrice;
		}

		return newLine;
	});

	// Put it at the end if an int wasn't provided or it's beyond the length of the state
	if(!isInteger(pos) || pos > state.length) {
		return [ ...state, ...newLines ];
	}

	// If updating the last line, insert a new blank line at the end
	if(pos === state.length-1 || state.length === 0) {
		let taxCode = action.taxCode || defaultTaxCode;

		let lines = [ ...state.slice(0, pos), ...newLines, {...lineTemplate, TaxCode: (action.taxCode || defaultTaxCode)} ];

		if(taxCode === defaultTaxCode) {
			for(let i = lines.length - 1; i >= 0; i--) {
				if(lines[i].TaxCode !== defaultTaxCode) {
					lines[lines.length-1].TaxCode = lines[i].TaxCode;
					break;
				}
			}
		}

		if(lines.length > 1 && !lines[lines.length-1].Item && !lines[lines.length-2].Item) {
			lines.splice(lines.length-1, 1);
		}

		return lines;
	}

	// Replaces the line at pos, and inserts additional lines afterward if necessary
	return [ ...state.slice(0, pos), ...newLines, ...state.slice(pos+1) ];
}


/*
Key: '',
	Item: '',
	Description: '',
	LineStatus: 'O',
	WhsCode: '',
	Qty: 0,
	Price: 0,
	LineTotal: 0,
	SubCatNum: '',
	PoTrgNum: '',
	UomCode: '',
	DiscountByPercent: 0,
 */

function recalculateAmounts(oldLine, newLine) {
	if(!oldLine.removable) {
		//return oldLine;
	}
	// Determine if this is something we're loading
	if(!oldLine.Key && oldLine.Key !== 0 && (newLine.Key || newLine.Key === 0)) oldLine = {...newLine};

	// Handle quantity pricing
	let prices,
		priceKeys,
		oldQty = oldLine.Qty || 0,
		newQty = newLine.Qty || 0;

	if(oldQty < 0) oldQty = 0;
	if(newQty < 0) newQty = 0;

	if(newLine.prices) {
		prices = newLine.prices;
		priceKeys = newLine.priceKeys;
	} else {
		prices = {'0': { Price: (oldLine.Price || 0) }};
		priceKeys = [0];
	}

	let oldPriceLevel = priceKeys.find(level => { return level <= Number(oldQty) });
	let newPriceLevel = priceKeys.find(level => { return level <= Number(newQty) });

	if(oldPriceLevel !== newPriceLevel) {
		newLine.Price = prices[newPriceLevel.toString()].Price;
	}
	// End quantity pricing

	if(!newLine.hasOwnProperty('BasePrice')) {
		newLine.BasePrice = newLine.Price;
	}
	let basePrice = Number(newLine.BasePrice || 0);

	let total     = {previous: oldLine.LineTotal, current: newLine.LineTotal};
	let price     = {previous: oldLine.Price, current: newLine.Price};
	let discount  = {previous: oldLine.DiscountByPercent, current: newLine.DiscountByPercent};
	let quantity  = {previous: oldLine.Qty, current: newLine.Qty};


	if(total.previous !== total.current && oldLine.removable === true) {
		let lineTotal = Number(total.current || 0) || 0;
		if(isNaN(lineTotal)) lineTotal = 0;

		let unitPrice = lineTotal / Number(quantity.current || 0);
		unitPrice = Number(unitPrice.toFixed(6));
		let dcpct = ((basePrice - unitPrice) / basePrice) * 100;
		dcpct = Number(dcpct.toFixed(6));
		if (isNaN(dcpct) || Math.abs(dcpct) === Infinity) dcpct = 0;

		newLine.DiscountByPercent = dcpct;
		newLine.Price = unitPrice;
		return newLine;
	}

	if(price.previous !== price.current && oldLine.removable === true) {
		let unitPrice = Number(price.current) || 0;
		unitPrice = Number(unitPrice.toFixed(6));
		let dcpct = ((basePrice - unitPrice) / basePrice) * 100;
		dcpct = Number(dcpct.toFixed(6));


		if (isNaN(dcpct) || Math.abs(dcpct) === Infinity) dcpct = 0;
		newLine.DiscountByPercent = dcpct;
		newLine.LineTotal = Number(((quantity.current * unitPrice)).toFixed(6));
		return newLine;
	}

	if(discount.previous !== discount.current && oldLine.removable === true) {
		if(!basePrice) {
			newLine.DiscountByPercent = 0;
			return newLine;
		}

		let dcpct = Number(discount.current) || 0;
		dcpct = Number(dcpct.toFixed(6));
		if (isNaN(dcpct) || Math.abs(dcpct) === Infinity) dcpct = 0;
		let unitPrice = Number( (basePrice * (1 - (dcpct/100))).toFixed(6));
		unitPrice = Number(unitPrice.toFixed(6));

		newLine.DiscountByPercent = dcpct;
		newLine.Price = unitPrice;
		newLine.LineTotal = Number((unitPrice * quantity.current).toFixed(6));
		return newLine;
	}

	if(quantity.previous !== quantity.current && oldLine.removable === true) {
		let unitPrice = Number(price.current) || 0;
		unitPrice = Number(unitPrice.toFixed(6));
		let dcpct = ((basePrice - unitPrice) / basePrice) * 100;
		dcpct = Number(dcpct.toFixed(6));
		if (isNaN(dcpct) || Math.abs(dcpct) === Infinity) dcpct = 0;
		let qty = Number(quantity.current) || 0;

		newLine.DiscountByPercent = dcpct;
		newLine.LineTotal = Number(((unitPrice * qty)).toFixed(6));
		return newLine;
	}

	return newLine;
}